import type { SVGProps } from 'react';

export function LeafIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.074 2.651a.91.91 0 0 1 .911-.206.9.9 0 0 1 .615.855v7.009c0 4.92-4.054 8.891-8.955 8.891a6.66 6.66 0 0 1-6.281-4.451A6.28 6.28 0 0 0 4.2 19.5c0 .499-.401.9-.9.9a.9.9 0 0 1-.9-.9 8.1 8.1 0 0 1 8.1-8.1h3c.499 0 .9-.401.9-.9s-.401-.9-.9-.9h-3a9.8 9.8 0 0 0-4.163.919 6.6 6.6 0 0 1 6.263-4.52c2.49.001 4.342-.828 5.576-1.649.72-.48 1.332-1.054 1.902-1.699z" />
    </svg>
  );
}
